import React from 'react';
import styled from 'styled-components';

const ThisFooter = styled.footer`
  position: absolute;
  bottom: 0;
  text-align: center;
  padding: 20px 0 10px;
  background-color: #393939;
  width: 100%;
  font-size: 11px;

  ul {
    padding: 0;

    li {
      display: inline;
      list-style: none;
      color: white;
      padding: 0 5px;

      a {
        color: #00AD83;
      }
      a:hover {
        text-decoration: none;
      }
    }
  }
`;

const FooterUI = () => (
  <ThisFooter>
    <ul>
      <li>
      WWWorld Cup is an experiment by <a href="https://faculty.co/" target="_blank" rel="noopener noreferrer">Faculty</a> and friends.
      </li>
      <li>|</li>
      <li>
      WWWorld Cup is not licensed by or otherwise affiliated with FIFA or FIFAPro.
      </li>
    </ul>
  </ThisFooter>
);

export default FooterUI;



// WEBPACK FOOTER //
// ./src/components/ui/FooterUI.js